export default {
	"scanPay.PaymentFailed": "Payment failed!",
	"scanPay.PaymentCancellation": "Payment Cancellation",
	"scanPay.networkAnomaly": "network anomaly",
	"scanPay.paymentSuccessful": "payment successful",
	"scanPay.PleaseUseWeChatOrAlipayToScanTheQRCodeToPay": "Please use WeChat or Alipay to scan the QR code to pay",
	"scanPay.TheOrderIsAbnormalPleaseTryAgainLater": "The order is abnormal, please try again later",
	"scanPay.PaymentAmount": "Payment amount",
	"scanPay.toPay": "to pay"
}